import InitTrainingCategoriesLogic from "./TrainingCategories.logic";

const TrainingCategoriesComponent: React.FC = () => {
    const {
        categories, categoryForm, editingCategoryId,
        onCategoryChange, onCategorySave, onCategoryEdit, onCategoryDelete, resetCategoryForm,
        typeForm, editingTypeId,
        onTypeChange, onTypeSave, onTypeEdit, onTypeDelete, resetTypeForm,
    } = InitTrainingCategoriesLogic();

    return (
        <div className="page-container">
            <h1 className="text-align-center">Usluge</h1>

            <div className="card">
                <h3>{editingCategoryId ? "Izmeni kategoriju" : "Dodaj kategoriju"}</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div>
                        <label htmlFor="categoryName">Naziv kategorije</label>
                        <input id="categoryName" type="text" placeholder="Npr. Individualni, Duo, Grupa..." value={categoryForm.name} onChange={onCategoryChange} name="name"></input>
                    </div>
                    <button className="btn-primary" type="button" onClick={onCategorySave}>{editingCategoryId ? "Sačuvaj izmene" : "Dodaj kategoriju"}</button>
                    {editingCategoryId && <button className="btn-secondary" type="button" onClick={resetCategoryForm}>Otkaži</button>}
                </div>
            </div>

            <div className="card" style={{ marginTop: '12px' }}>
                <h3>{editingTypeId ? "Izmeni tip treninga" : "Dodaj tip treninga"}</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div>
                        <label htmlFor="typeCategoryId">Kategorija</label>
                        <select id="typeCategoryId" value={typeForm.trainingCategoryId} onChange={onTypeChange} name="trainingCategoryId">
                            <option value={0}>-- Izaberi kategoriju --</option>
                            {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                        </select>
                    </div>
                    <div>
                        <label htmlFor="typeName">Naziv</label>
                        <input id="typeName" type="text" placeholder="Npr. Individualni paket, 1 grupni trening..." value={typeForm.name} onChange={onTypeChange} name="name"></input>
                    </div>
                    <div>
                        <label htmlFor="typePrice">Cena uplate</label>
                        <input id="typePrice" type="number" inputMode="numeric" min={0} step={1} value={typeForm.price} onChange={onTypeChange} name="price"></input>
                    </div>
                    <div>
                        <label htmlFor="typeQuantity">Količina (broj treninga)</label>
                        <input id="typeQuantity" type="number" inputMode="numeric" min={1} step={1} value={typeForm.quantity} onChange={onTypeChange} name="quantity"></input>
                    </div>
                    <div>
                        <label htmlFor="typeDurationWeeks">Trajanje paketa u nedeljama (ostaviti prazno ako je u mesecima)</label>
                        <input id="typeDurationWeeks" type="number" inputMode="numeric" min={0} step={1} value={typeForm.durationWeeks} onChange={onTypeChange} name="durationWeeks"></input>
                    </div>
                    <div>
                        <label htmlFor="typeDurationMonths">Trajanje paketa u mesecima (ostaviti prazno ako je u nedeljama)</label>
                        <input id="typeDurationMonths" type="number" inputMode="numeric" min={0} step={1} value={typeForm.durationMonths} onChange={onTypeChange} name="durationMonths"></input>
                    </div>
                    <button className="btn-primary" type="button" onClick={onTypeSave}>{editingTypeId ? "Sačuvaj izmene" : "Dodaj tip"}</button>
                    {editingTypeId && <button className="btn-secondary" type="button" onClick={resetTypeForm}>Otkaži</button>}
                </div>
            </div>

            <div style={{ marginTop: '16px' }}>
                <h3>Kategorije i tipovi treninga</h3>
                {categories.map((category) =>
                    <div className="card" key={category.id} style={{ marginTop: '12px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                            <h4 style={{ margin: 0 }}>{category.name}</h4>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <button className="btn-small btn-secondary" type="button" onClick={() => onCategoryEdit(category)}>Izmeni</button>
                                <button className="btn-small btn-danger" type="button" onClick={() => onCategoryDelete(category.id)}>Obriši</button>
                            </div>
                        </div>
                        {category.trainingTypes?.length > 0 ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '8px' }}>
                                {category.trainingTypes.map((type: any) =>
                                    <div key={type.id} style={{ padding: '8px', borderBottom: '1px solid var(--border)' }}>
                                        <p style={{ fontWeight: 500 }}>{type.name}</p>
                                        <p style={{ fontSize: '0.85rem', opacity: 0.8, margin: '4px 0' }}>
                                            Cena: {type.price} din, Količina: {type.quantity},
                                            Trajanje: {type.durationWeeks ? `${type.durationWeeks} ned.` : type.durationMonths ? `${type.durationMonths} mes.` : "-"}
                                        </p>
                                        <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                                            <button className="btn-small btn-secondary" type="button" onClick={() => onTypeEdit(type)}>Izmeni</button>
                                            <button className="btn-small btn-danger" type="button" onClick={() => onTypeDelete(type.id)}>Obriši</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <p style={{ opacity: 0.6 }}>Nema tipova treninga u ovoj kategoriji</p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TrainingCategoriesComponent;
